import doRequest from "services/helpers";
import { getToken } from "services/auth/tokenAuth";
import { getUserId } from "services/storage/general";
import { parseToChangeHistoryItem, parseToStudentPenaltyAdmin } from "./helpers";

export const requestGetStudentPenalties = async ({
    studentId,
    penaltyStartDate,
    page,
    tab
}) => {
    const [result, err] = await doRequest(
        "/RecursoAdminSancion/Leer", "POST", 
        {
            codigoEstudiante: studentId,
            fechaInicioSancion: penaltyStartDate,
            pagina: page,
            tab,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    const {
        tabs,
        sanciones
    } = data.data;
    return {
        tabs: {
            current: tabs.Vigentes,
            expired: tabs.Caducados,
            removed: tabs.Eliminados
        },
        penalties: sanciones?.map(parseToStudentPenaltyAdmin) || null
    };
}
export const requestUpdateStudentPenalty = async ({
    id, penalizeDays,
    blockId
}) => {
    const [result, err] = await doRequest(
        "/RecursoAdminSancion/Editar", "POST",
        {
            idSancion: id,
            dias: parseInt(penalizeDays) || -1,
            idBloqueo: blockId,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    return data.data.exito;
}
export const requestDeleteStudentPenalty = async studentPenaltyId => {
    const [result, err] = await doRequest(
        "/RecursoAdminSancion/Eliminar", "POST",
        {
            idSancion: studentPenaltyId,
            codigoUsuario: getUserId(),
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    return data.data.exito;
}
export const requestGetChangeHistoryStudentPenalty = async studentPenaltyId => {
    const [result, err] = await doRequest(
        `/RecursoAdminSancion/Historial/${studentPenaltyId}`, "GET",
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    const { historial } = data.data;
    return historial.map(parseToChangeHistoryItem);
}